import React from 'react';
import { FadeIn } from './ui/FadeIn';
const comparisons = [{
  bad: 'Salís y esperás aguantar',
  good: 'Salís con un objetivo claro'
}, {
  bad: 'Las subidas te destruyen',
  good: 'Las subidas son parte del plan'
}, {
  bad: 'Cada cierre genera ansiedad',
  good: 'Cada salida es un proceso medible'
}, {
  bad: 'Llegás solo a la cima',
  good: 'Llegás con el grupo'
}, {
  bad: 'Entrenás con kilómetros basura',
  good: 'Entrenás con estímulos progresivos'
}, {
  bad: 'Gastás en geles importados de $4.000',
  good: 'Fabricás los tuyos por $300'
}];
export function ComparisonTable() {
  return <section className="py-16 px-4 bg-slate-950" aria-labelledby="comparison-heading" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <FadeIn className="text-center mb-10" data-id="element-35">
          <h2 id="comparison-heading" className="text-3xl md:text-4xl font-serif font-bold text-white italic tracking-wide" data-id="element-36">
            LO QUE CAMBIA EN TU PRÓXIMA SALIDA
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-37">
          <div className="bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden shadow-xl" data-id="element-38">
            <table className="w-full" role="table" aria-label="Comparación: Sin el Método vs Con PROTORRENDA 4-12" data-id="element-39">
              <thead data-id="element-40">
                <tr className="bg-slate-950 border-b border-slate-700" data-id="element-41">
                  <th scope="col" className="p-5 text-center text-red-500 font-bold text-base md:text-lg" data-id="element-42">
                    <span aria-hidden="true" data-id="element-43">❌</span> Sin el Método
                  </th>
                  <th scope="col" className="p-5 text-center text-green-500 font-bold text-base md:text-lg border-l border-slate-700" data-id="element-44">
                    <span aria-hidden="true" data-id="element-45">✅</span> Con PROTORRENDA 4-12
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-800" data-id="element-46">
                {comparisons.map((row, i) => <tr key={i} data-id="element-47">
                    <td className="p-5 text-center text-slate-400 text-sm md:text-base" data-id="element-48">
                      {row.bad}
                    </td>
                    <td className="p-5 text-center text-white font-bold text-sm md:text-base border-l border-slate-800" data-id="element-49">
                      {row.good}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </FadeIn>
      </div>
    </section>;
}